'use strict';

const {
  bindToggleDrawers,
} = require('../../deal/responsive/frontend/bind_toggle_drawers');

const FinePrint = {
  optionSpecificFinePrint(finePrint) {
    const $finePrintDesc = document.querySelector('.fine-print-description');
    if (!$finePrintDesc) {
      return;
    }

    if (!window.BuyButtonEventPipe) {
      return;
    }

    window.BuyButtonEventPipe.on('option_updated', ({ optionUuid }) => {
      if (finePrint && finePrint.optionSpecificDescriptions[optionUuid]) {
        $finePrintDesc.innerHTML =
          finePrint.optionSpecificDescriptions[optionUuid];
      }
    });
  },

  init({ finePrint }, done) {
    bindToggleDrawers();
    this.optionSpecificFinePrint(finePrint);
    return done();
  },
};

module.exports = FinePrint;
